import { Platform } from 'react-native';
import { IFile } from '@coverflex-tech/hypernova-utils';

const buildFormDataKeys = (data: any, parentKey: string) => {
  let allKeys: { key: string; value: any }[] = [];

  if (
    data &&
    typeof data === 'object' &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      const dataKeys = buildFormDataKeys(
        data[key],
        parentKey
          ? Array.isArray(data)
            ? `${parentKey}[]`
            : `${parentKey}[${key}]`
          : key
      );
      allKeys = [...allKeys, ...dataKeys];
    });
  } else {
    const value = data == null ? '' : data;
    allKeys.push({
      key: parentKey,
      value,
    });
  }
  return allKeys;
};

export const getFormDataFromObject = (payload: any, parentKey?: string) => {
  const formData = new FormData();
  const dataKeys = buildFormDataKeys(payload, parentKey ?? '');
  dataKeys.forEach((dataKey) => formData.append(dataKey.key, dataKey.value));
  return formData;
};

export function addFilesFormData(
  formData: FormData,
  key: string,
  files: IFile[]
) {
  prepareFiles(files).forEach((file) => {
    // We need to cast the file to any because the file can be an object
    formData.append(key, file as any);
  });
}

function prepareFiles(files: IFile[]) {
  if (Platform.OS === 'web') {
    return files.map((file) => file.blob);
  }

  return files.map((file) => ({
    uri: file.url,
    name: file.name,
    type: file.contentType,
  }));
}
